import { useState, useEffect } from "react";
import { PaginationProps } from "@campgladiator/cgui-core.atoms.pagination";
import { breakpoints } from "@campgladiator/cgui-core.utilities.helpers.resolution-variables";
import { useDeviceWidth } from "@campgladiator/cgui-core.utilities.hooks.use-device-width";

const { tabletSmall } = breakpoints;

const useTable = () => {
  const [paginationSize, setPaginationSize] =
    useState<PaginationProps["size"]>("default");
  const deviceWidth = useDeviceWidth();

  useEffect(() => {
    if (deviceWidth >= tabletSmall) {
      setPaginationSize("default");
    } else {
      setPaginationSize("small");
    }
  }, [deviceWidth]);

  return {
    paginationSize,
    deviceWidth,
  };
};

export default useTable;
